import { SimCardActiveOutput } from './sim-card-active-output.model';


export class SimCardSelectActiveOutput implements ISimCardSelectActiveOutput {
    status!: number;
    message!: string;
    data!: SimCardActiveOutput[];

    constructor(data?: ISimCardSelectActiveOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SimCardActiveOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SimCardSelectActiveOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SimCardSelectActiveOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISimCardSelectActiveOutput {
    status: number;
    message: string;
    data: SimCardActiveOutput[];
}

